/**
 * @description 获取域名:端口
 * @returns {string}
 */
export const addressBarHost = (): string => location.host
